import { useState, useEffect, useRef } from 'react';

function useActiveElement() {
    const [active, setActive] = useState(document === null || document === void 0 ? void 0 : document.activeElement);
    const handleFocusIn = () => {
        setActive(document === null || document === void 0 ? void 0 : document.activeElement);
    };
    useEffect(() => {
        document === null || document === void 0 ? void 0 : document.addEventListener("focusin", handleFocusIn);
        return () => {
            document === null || document === void 0 ? void 0 : document.removeEventListener("focusin", handleFocusIn);
        };
    }, []);
    return active;
}

const PORTAL_FOCUS_ATTRIBUTE_NAME = "data-atl-maintain-portal-focus";
const formFieldFocusAttribute = {
    [PORTAL_FOCUS_ATTRIBUTE_NAME]: "true",
};
function useFormFieldFocus(props) {
    var _a;
    const [focused, setFocused] = useState(false);
    const activeElement = useActiveElement();
    const activeElementRef = useRef(activeElement);
    useEffect(() => {
        activeElementRef.current = activeElement;
    }, [activeElement]);
    function handleFocusIn() {
        setFocused(true);
    }
    function handleFocusOut() {
        setTimeout(() => {
            var _a, _b, _c;
            const focusedElementWithinWrapper = (_b = (_a = props.wrapperRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.contains(document.activeElement);
            const focusException = (_c = activeElementRef.current) === null || _c === void 0 ? void 0 : _c.closest(`[${PORTAL_FOCUS_ATTRIBUTE_NAME}='true']`);
            if (!focusedElementWithinWrapper && !focusException) {
                setFocused(false);
            }
        }, 1);
    }
    useEffect(() => {
        var _a, _b, _c, _d;
        (_b = (_a = props.wrapperRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.addEventListener("focusin", handleFocusIn);
        (_d = (_c = props.wrapperRef) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.addEventListener("focusout", handleFocusOut);
        return () => {
            var _a, _b, _c, _d;
            (_b = (_a = props.wrapperRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.removeEventListener("focusin", handleFocusIn);
            (_d = (_c = props.wrapperRef) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.removeEventListener("focusout", handleFocusOut);
        };
    }, [(_a = props.wrapperRef) === null || _a === void 0 ? void 0 : _a.current]);
    return {
        focused,
    };
}

export { formFieldFocusAttribute as f, useFormFieldFocus as u };
